import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=499a2bd3&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499a2bd3')) {
      api.createRecord('499a2bd3', component.options)
    } else {
      api.reload('499a2bd3', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=499a2bd3&", function () {
      api.rerender('499a2bd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/gateway/edit.vue"
export default component.exports